<style>

</style>

<template>
    <v-container grid-list-md>
      <v-layout row wrap v-if="chart.schema">
        <v-flex :key="index" :class="item.class" v-for="(item, index) in chart.schema">
            <v-text-field :label="item.label" placeholder=" " outline v-if="item.type == 'input'"></v-text-field>
            <v-select v-if="item.type == 'select'" :items="item.list" :label="item.label" item-text="label" item-value="value" v-model="item.model" outline></v-select>
            <v-menu
            v-if="item.type == 'date'"
        v-model="item.menu"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :label="item.label"
            prepend-icon="event"
            v-model="item.model"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="item.model" @input="item.menu = false"></v-date-picker>
      </v-menu>
          <v-btn color="blue-grey" class="white--text" v-if="item.type == 'button'">
              <v-icon right dark>search</v-icon> &nbsp;&nbsp;&nbsp;
              {{ item.label }}
            </v-btn>
        </v-flex>
    </v-layout>
    </v-container>
</template>
<script>
export default {
    data: function() {
        return {
            componentKey: 0
        };
    },
    props: ['chart'],
    components: {

    },
    methods: {
     
    },
    mounted() {

    }
}

</script>
